<template>
  <section :class="[`${component.toLowerCase()}`, 'c-base-section']">
    <BaseSectionHeading :data="data" />

    <component
      :is="component"
      :data="data"
    />
  </section>
</template>

<script>
import BaseSectionHeading from '@/components/BaseSectionHeading.vue';
import VideoComp from '@/components/VideoComp.vue';
import Slideshow from '@/components/Slideshow.vue';
import Showcase from '@/components/Showcase.vue';
import Mirrored from '@/components/Mirrored.vue';
import BigImage from '@/components/BigImage.vue';
import BigVideo from '@/components/BigVideo.vue';
import Sponsor from '@/components/Sponsor.vue';
import MapComp from '@/components/MapComp.vue';
import WorkshopsItem from '@/components/WorkshopsItem.vue';
import Timetable from '@/components/Timetable.vue';


export default {
  name: 'baseSection',

  components: {
    BaseSectionHeading,
    VideoComp,
    Slideshow,
    BigImage,
    BigVideo,
    Showcase,
    Mirrored,
    Sponsor,
    MapComp,
    WorkshopsItem,
    Timetable,
  },

  props: {
    component: {
      type: String,
      required: true,
    },

    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-base-section {
  position: relative;
  width: 100%;
  padding: 60px 20px;

  overflow: hidden;

  @include mq(mobile) {
    padding: 40px 30px;
  }

  @include mq(ipadP) {
    padding: 80px 40px;
  }

  @include mq(ipadL) {
    padding: 100px 80px;
  }

  &--no-padding-top {
    padding-top: 0;
  }
}
</style>
